import _extends from "@babel/runtime/helpers/extends";
import _pt from "prop-types";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { css } from '@emotion/react';
import React, { Children, isValidElement } from 'react';
import Button from './Button';
import Dropdown from './Dropdown';
import useMenu from './useMenu';
import { jsx as ___EmotionJSX } from "@emotion/react";
var wrapperStyle = process.env.NODE_ENV === "production" ? {
  name: "193sxzf",
  styles: "align-items:center;display:inline-flex;position:relative"
} : {
  name: "1v7c3gs-wrapperStyle",
  styles: "align-items:center;display:inline-flex;position:relative;label:wrapperStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Menu(_ref) {
  var avatarUrl = _ref.avatarUrl,
      children = _ref.children,
      dropdownOffset = _ref.dropdownOffset,
      showAlertDot = _ref.showAlertDot,
      totalXp = _ref.totalXp,
      triggerTrackId = _ref.triggerTrackId;
  // Number of non-null, non-undefined, and non-false children
  var numberOfItems = Children.toArray(children).length; // Render only valid children to keep it in sync with numberOfItems

  function renderValidChildren() {
    return Children.toArray(children).filter(function (child) {
      return /*#__PURE__*/isValidElement(child);
    });
  }

  var _useMenu = useMenu(numberOfItems),
      buttonProps = _useMenu.buttonProps,
      isOpen = _useMenu.isOpen,
      itemsProps = _useMenu.itemsProps;

  return ___EmotionJSX("div", {
    css: wrapperStyle
  }, ___EmotionJSX(Button, _extends({
    avatarUrl: avatarUrl,
    isOpen: isOpen,
    showAlertDot: showAlertDot
  }, buttonProps, {
    "aria-label": "My Account",
    "data-testid": "user-account-menu-button",
    "data-trackid": triggerTrackId
  })), isOpen && ___EmotionJSX(Dropdown, {
    itemsProps: itemsProps,
    offset: dropdownOffset,
    totalXp: totalXp
  }, renderValidChildren()));
}

Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  avatarUrl: _pt.string,
  children: _pt.node.isRequired,
  dropdownOffset: _pt.number,
  showAlertDot: _pt.bool,
  totalXp: _pt.number,
  triggerTrackId: _pt.string
} : {};
export default Menu;